/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';
import { AccessSubTab } from './AccessFilterHeader';

interface AccessSubTabsProps {
  subTab: AccessSubTab;
  onSubTabChange: (val: AccessSubTab) => void;
}

export const AccessSubTabs: React.FC<AccessSubTabsProps> = ({
  subTab,
  onSubTabChange,
}) => {
  return (
    <div css={subTabsRowStyle}>
      <div css={underlineNavStyle}>
        <span
          css={subTabItemStyle(subTab === 'overview')}
          onClick={() => onSubTabChange('overview')}
        >
          Tổng quan
        </span>
        <span
          css={subTabItemStyle(subTab === 'users')}
          onClick={() => onSubTabChange('users')}
        >
          Người dùng
        </span>
        <span
          css={subTabItemStyle(subTab === 'frequency')}
          onClick={() => onSubTabChange('frequency')}
        >
          Tần suất
        </span>
        <span
          css={subTabItemStyle(subTab === 'avg_time')}
          onClick={() => onSubTabChange('avg_time')}
        >
          Thời gian sử dụng
        </span>
      </div>
    </div>
  );
};

const subTabsRowStyle = css`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  padding-right: 4px;
`;

const underlineNavStyle = css`
  display: flex;
  gap: 32px;
`;

const subTabItemStyle = (active: boolean) => css`
  font-size: 15px;
  font-weight: ${active ? 600 : 400};
  color: ${active ? '#1890ff' : '#595959'};
  cursor: pointer;
  padding-bottom: 8px;
  border-bottom: ${active ? '2px solid #1890ff' : '2px solid transparent'};
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    color: #1890ff;
  }
`;
